import { compare } from '../unknowns/compare';

type EqualityCondition<T, P> = (item: T, itemToCompare: P) => boolean;

export const intersectsBy = <T, P>(
  array1: T[],
  array2: P[],
  equalityCondition: EqualityCondition<T, P> = compare
): T[] => array1.filter(el1 => array2.some(el2 => equalityCondition(el1, el2)));
